export enum TransactionStatus {
  PENDING = 'P',
  INPROCESS = 'I',
  COMPLETED = 'C',
  CANCELLED_TRANSACTION = 'X',
  SENT = 'S'
}

export enum TransactionType {
  DIRECT_ORDER = 'DO',
  QUOTATION = 'Q',
  ORDER = 'O',
  INVOICE = 'I'
}